import { API, AUTH_CONTEXT } from "./api";
import { loadMutation } from "./utils";

export default async (endpoint, data) => {
  let token = localStorage.getItem("token");
  let context = {};
  if (token !== "" && token !== null && token !== undefined) {
    context.headers = {
      authorization: AUTH_CONTEXT(),
    };
  }
  const PAYLOAD = {
    mutation: await loadMutation(endpoint),
    variables: data,
    context,
  };

  return API.BURSE_API.mutate(PAYLOAD).then((result) => result.data[endpoint]);
};
